import React from 'react';
import { string } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon, Button, Tooltip } from '@fiverr-private/fit';
import { r_exclamation_triangle, s_exclamation_circle } from '@fiverr-private/icons/basic';
import { daysToDeadline } from '../utils';

import './style.scss';

const TRANSLATIONS_PREFIX = 'layout.global_messages.identity_verification';

/**
 * Redirect the user to the identity verification flow
 */
const redirectToVerificationPage = () => {
    window.open(pathfinder('id_verification', { step_id: 'welcome' }));
};

const DeadlineDays = ({ deadline }) => {
    const days = daysToDeadline(deadline);

    return (
        days === 1 ?
            <I18n k={`${TRANSLATIONS_PREFIX}.day`}/> :
            <I18n k={`${TRANSLATIONS_PREFIX}.days`} params={{ days }}/>
    );
};

const TooltipContent = ({ deadline }) => (
    <>
        <I18n k={`${TRANSLATIONS_PREFIX}.tooltip.headline_1`}/>
        <DeadlineDays deadline={deadline}/>
        <I18n k={`${TRANSLATIONS_PREFIX}.tooltip.headline_2`}/>
        <ul className="id-verification-tooltip-list">
            <li><I18n k={`${TRANSLATIONS_PREFIX}.tooltip.restriction_1`}/></li>
            <li><I18n k={`${TRANSLATIONS_PREFIX}.tooltip.restriction_2`}/></li>
            <li><I18n k={`${TRANSLATIONS_PREFIX}.tooltip.restriction_3`}/></li>
        </ul>
    </>
);

const IdentityVerification = ({ deadline }) => (
    <div className="identity-verification-message-wrapper">
        <div className="identity-verification-message-section">
            <div className="message-content">
                <div className="message-icon">
                    <Icon color="white" size={22}>
                        {r_exclamation_triangle}
                    </Icon>
                </div>
                <div className="message-text">
                    <I18n k={`${TRANSLATIONS_PREFIX}.title_1`}/>
                    <DeadlineDays deadline={deadline}/>
                    <I18n k={`${TRANSLATIONS_PREFIX}.title_2`}/>
                </div>
                <Tooltip className="identity-verification-tooltip"
                    boxContentClassName="identity-verification-tooltip-content"
                    position={Tooltip.POSITIONS.BOTTOM}
                    content={<TooltipContent deadline={deadline}/>}>
                    <Icon className="information-icon" color="white" size={14}>
                        {s_exclamation_circle}
                    </Icon>
                </Tooltip>
            </div>
            <Button className="link-provider tbody-6"
                onClick={redirectToVerificationPage}
                textColor={Button.TEXT_COLORS.DARK_GREY}
                color={Button.COLORS.WHITE}
                fill={Button.FILLS.FULL}>
                <I18n k={`${TRANSLATIONS_PREFIX}.verify_now`}/>
            </Button>
        </div>
    </div>
);

DeadlineDays.propTypes = {
    deadline: string.isRequired
};

TooltipContent.propTypes = {
    deadline: string.isRequired
};

IdentityVerification.propTypes = {
    deadline: string.isRequired
};

export default IdentityVerification;
